// removed by extract-text-webpack-plugin
module.exports = {"container":"VACg","note-link":"GNcC","red":"_3qww","blue":"_2LAr","green":"zumW","dark-blue":"_2qDR","yellow":"_3UJX","purple":"_13aj","pink":"_2YCi","requirements":"_2bSP","title":"_-66u","tag":"_3myA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Above/styles.scss
// module id = 67
// module chunks = 0